/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="split-maintenance-container">
    
    <div class="brand-panel">
      <div class="brand-overlay-pattern"></div>
      <div class="illustration-wrapper">
        <div class="circle-bg circle-1"></div>
        <div class="circle-bg circle-2"></div>
        
        <img src="@/assets/images/Mantenimiento.png" alt="Ingeniero ANIATEK trabajando" class="tech-illustration" />
      </div>
      <div class="brand-footer">
        <h3 class="brand-name">ANIATEK</h3>
        <p>Potenciando tus proyectos.</p>
      </div>
    </div>

    <div class="message-panel">
      <div class="message-content">
        
        <span class="status-badge">
          <span class="pulsing-dot"></span>
          Actualización en curso
        </span>

        <h1 class="hero-title">
          Estamos construyendo<br>
          <span class="highlight-text">algo mejor para ti.</span>
        </h1>

        <p class="hero-subtitle">
          Nuestro equipo de ingeniería está implementando mejoras importantes en la plataforma. 
          <br><br>
          "Estamos trabajando para traerte lo mejor, danos un momento, regresa pronto."
        </p>

        <div class="action-buttons">
          <button class="btn-hero-large" @click="recargarPagina">
            Revisar estado ahora
          </button>
          
          <a href="mailto:energyaniasolar@gmail.com" class="secondary-link">
            <i class="fa-regular fa-envelope"></i> Necesito soporte urgente
          </a>
        </div>
      </div>

      <div class="message-footer">
        Ticket de mantenimiento #STK-UPDT-24
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SitioCerrado',
  methods: {
    recargarPagina() {
      const btn = document.querySelector('.btn-hero-large');
      
      if (btn) {
        btn.innerText = 'Verificando...';
        btn.disabled = true;
      }
      
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  }
}
</script>

<style scoped>
.split-maintenance-container {
  --w-primary: #29b9f6;
  --w-accent-orange: #29b9f6;
  --w-dark-blue: #0f172a; 
  --w-text-main: #334155;
  --w-text-muted: #64748b;
  --font-stack: 'Inter', sans-serif;

  display: flex;
  min-height: 100vh;
  width: 100%;
  font-family: var(--font-stack);
  background: #ffffff;
  overflow: hidden;
}

.brand-panel {
  flex: 0.8;
  background: linear-gradient(135deg, var(--w-dark-blue) 0%, var(--w-primary) 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: white;
  overflow: hidden;
}

.brand-overlay-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.1;
  background-image: radial-gradient(circle at 2px 2px, rgba(255,255,255,0.8) 1px, transparent 0);
  background-size: 32px 32px;
}

.illustration-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.tech-illustration {
  width: auto;
  height: 100%;
  max-height: 450px;
  object-fit: contain;
  position: relative;
  z-index: 5;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
}

.circle-bg {
  position: absolute;
  border-radius: 50%;
}

.circle-1 {
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.05);
  top: 10%;
  left: 10%;
}

.circle-2 {
  width: 300px;
  height: 300px;
  background: rgba(47, 141, 183, 0.3);
  bottom: 10%;
  right: 10%;
  filter: blur(40px);
}

.brand-footer {
  position: absolute;
  bottom: 30px;
  left: 40px;
  z-index: 10;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 2px;
  margin: 0;
}

.brand-footer p {
  margin: 5px 0 0 0;
  opacity: 0.8;
  font-size: 0.9rem;
}

.message-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 80px;
  background: #ffffff;
  position: relative;
}

.message-content {
  max-width: 550px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  background: #fff3e0;
  color: var(--w-accent-orange);
  padding: 8px 16px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 30px;
}

.pulsing-dot {
  width: 8px;
  height: 8px;
  background-color: var(--w-accent-orange);
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 0 0 0 rgba(152, 77, 33, 0.7);
  animation: badge-pulse 2s infinite;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  color: var(--w-dark-blue);
  line-height: 1.1;
  margin-bottom: 25px;
}

.highlight-text {
  color: var(--w-primary);
}

.hero-subtitle {
  font-size: 1.1rem;
  color: var(--w-text-muted);
  line-height: 1.6;
  margin-bottom: 45px;
  border-left: 4px solid #e2e8f0;
  padding-left: 20px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.btn-hero-large {
  background-color: var(--w-accent-orange); 
  color: white;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: background 0.2s, transform 0.2s;
  box-shadow: 0 4px 10px -2px rgba(152, 77, 33, 0.4);
}

.btn-hero-large:hover {
  background-color: #7c3e1b;
  transform: translateY(-2px);
}
.btn-hero-large:disabled {
    background-color: var(--w-text-muted);
    cursor: not-allowed;
    transform: none;
}

.secondary-link {
  color: var(--w-text-muted);
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s;
}

.secondary-link:hover {
  color: var(--w-primary);
}

.message-footer {
  position: absolute;
  bottom: 30px;
  font-size: 0.85rem;
  color: #cbd5e1;
  font-family: monospace;
}

@keyframes badge-pulse {
	0% { box-shadow: 0 0 0 0 rgba(152, 77, 33, 0.7); }
	70% { box-shadow: 0 0 0 10px rgba(152, 77, 33, 0); }
	100% { box-shadow: 0 0 0 0 rgba(152, 77, 33, 0); }
}

@media (max-width: 1024px) {
  .split-maintenance-container {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  .brand-panel {
    flex: none;
    height: 40vh;
    padding: 30px;
  }

  .illustration-wrapper {
    height: 100%;
  }
  
  .tech-illustration {
     max-height: 250px;
  }

  .brand-footer {
    display: none;
  }

  .message-panel {
    flex: none;
    padding: 40px 30px;
    min-height: 60vh;
  }

  .hero-title {
    font-size: 2rem;
  }
  
  .message-footer {
      position: relative;
      bottom: auto;
      margin-top: 40px;
  }
}
</style>